import type { GridGetRowsParams } from '@mui/x-data-grid-premium';
import { GridDataSourceCacheDefault } from '@mui/x-data-grid-premium';

/**
 * Cache entry identity for a Workflows list fetch. The grid's own key is
 * `[filterModel, sortModel, start, end]`, which leaves a grouped response and a flat
 * one — or two different expanded groups — sharing an entry and able to be served each
 * other's rows. Grouping and the group path decide the shape of the rows a request
 * returns, so they belong in the key.
 */
export function getWorkflowDataSourceCacheKey(params: GridGetRowsParams) {
  return JSON.stringify([
    params.groupFields ?? [],
    params.groupKeys ?? [],
    params.filterModel,
    params.sortModel,
    params.start,
    params.end,
  ]);
}

export function createWorkflowDataSourceCache() {
  // The default config types the key as the community params, which have no grouping.
  return new GridDataSourceCacheDefault({
    getKey: (params: GridGetRowsParams) => getWorkflowDataSourceCacheKey(params),
  });
}
